/** Форматирование времени, длительностей и чисел для интерфейса (всё по-русски). */

export function formatDuration(totalSec: number | null | undefined): string {
  if (totalSec == null || !Number.isFinite(totalSec)) return '—';
  const s = Math.max(0, Math.round(totalSec));
  if (s < 60) return `${s} с`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} мин${s % 60 && m < 10 ? ` ${s % 60} с` : ''}`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} ч${m % 60 ? ` ${m % 60} мин` : ''}`;
  const d = Math.floor(h / 24);
  return `${d} д${h % 24 ? ` ${h % 24} ч` : ''}`;
}

/** Живой таймер: 0:42, 12:05, 1:03:10 */
export function formatClock(totalSec: number): string {
  const s = Math.max(0, Math.floor(totalSec));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return h ? `${h}:${pad(m)}:${pad(sec)}` : `${m}:${pad(sec)}`;
}

const dtf = new Intl.DateTimeFormat('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
const tf = new Intl.DateTimeFormat('ru-RU', { hour: '2-digit', minute: '2-digit' });
const tfs = new Intl.DateTimeFormat('ru-RU', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
const df = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long' });

export const formatDateTime = (iso: string | null | undefined) => (iso ? dtf.format(new Date(iso)) : '—');
export const formatTime = (iso: string | null | undefined, seconds = false) =>
  iso ? (seconds ? tfs : tf).format(new Date(iso)) : '—';
export const formatDay = (iso: string) => df.format(new Date(iso));

export function formatRelative(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return '—';
  const sec = Math.round((now - new Date(iso).getTime()) / 1000);
  if (sec < 10) return 'только что';
  if (sec < 60) return `${sec} с назад`;
  if (sec < 3600) return `${Math.floor(sec / 60)} мин назад`;
  if (sec < 86400) return `${Math.floor(sec / 3600)} ч назад`;
  return formatDateTime(iso);
}

const nf = new Intl.NumberFormat('ru-RU');
export const formatNumber = (n: number | null | undefined) => (n == null ? '—' : nf.format(n));

export function formatMoney(n: number | null | undefined): string {
  if (n == null) return '—';
  if (n >= 1_000_000) return `$${(n / 1_000_000).toLocaleString('ru-RU', { maximumFractionDigits: 1 })}M`;
  if (n >= 1_000) return `$${Math.round(n / 1_000)}K`;
  return `$${nf.format(n)}`;
}

export const formatPercent = (v: number | null | undefined) => (v == null ? '—' : `${Math.round(v * 100)}%`);

export function initials(name: string | null | undefined): string {
  if (!name) return '?';
  const parts = name.replace(/[@_]/g, ' ').trim().split(/\s+/);
  return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase() || '?';
}

/** Стабильный цвет по строке (аватары). */
export function hueOf(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 360;
  return h;
}
